import React, {useState} from 'react'
import styled from 'styled-components'
import TitleH2 from "../components/titleH2";
import LabelInput from "../components/labelInput";
import Input from "../components/input";
import ButtonForm from "../components/buttonForm";
//---REDUX
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import allTheActions from '../actions'
//---
import Container from "../components/container";
import Button from "../components/button";
import Swal from "sweetalert2";

const TopContainer = styled.div`
  padding: 0 32px;
  max-width: 1024px;
  margin: auto;

  p:first-child {
    font-size: 20px;
  }

  p:nth-child(2) {
    font-size: 16px;
  }

  ul {
    margin-left: 48px;
  }
`

const Formulaire = styled.form`
  text-align: center;
  width: auto;
  margin-top: 50px;
`

const Horizontal = styled.div`
  display: flex;
  justify-content: center;
  width: auto;
  flex-wrap: wrap;
`

const Auth = props => {
    const [data, setData] = useState({})

    const handleChange = event => {
        setData({...data, [event.target.name]: event.target.value})
    }

    const handleClickSignIn = async event => {
        event.preventDefault()
        await props.actions.login.login(data)
    }

    const handleClickSignUp = async event => {
        event.preventDefault()
        data.idClub = 'none'
        data.admin = 'false'
        data.licenceSolo = 'none'
        if (await props.actions.user.create(data))
            Swal.fire(
                'Inscription réussie !',
                `Bienvenue, ${data.prenom}. Vous pouvez désormais vous connecter`,
                'success'
            ).then(() => window.location.reload())
    }

    return (
        <>
            <TopContainer>
                <p>
                    Pour toute création de licence, veuillez contacter Cédric Pandolfi par
                    email : <strong><u>cpandolfi.pando@gmail.com</u></strong>
                </p>
                <p>
                    Veuillez communiquer les informations suivantes :
                    <ul>
                        <li>Prénom</li>
                        <li>Nom</li>
                        <li>Date de naissance</li>
                        <li>Adresse postale</li>
                        <li>Adresse email</li>
                        <li>Numéro de téléphone</li>
                        <li>Nom du club ou licence individuelle</li>
                    </ul>
                </p>
            </TopContainer>
            <Horizontal>
                <Container padding="64px" width="100%" maxWidth="500px" backgroundColor="white">
                    <TitleH2 marginTop="0" textAlign="center" content="CONNEXION"/>
                    <Formulaire onSubmit={handleClickSignIn}>
                        <LabelInput redStar={true}>Adresse mail</LabelInput>
                        <Input name='mail' onChange={handleChange} width="100%"/><br/>
                        <LabelInput redStar={true}>Mot de passe</LabelInput>
                        <Input name='password' type='password' onChange={handleChange} width="100%"/><br/>
                        <ButtonForm name='envoyer'/>
                    </Formulaire>
                </Container>
                <Container padding="64px" width="100%" maxWidth="500px" backgroundColor="#204051" color="#fff">
                    <TitleH2 marginTop="0" textAlign="center" content="Inscription" color="#fff"/>
                    <Formulaire onSubmit={handleClickSignUp}>
                        <LabelInput redStar={true}>Adresse mail</LabelInput>
                        <Input name="mail" onChange={handleChange} width="100%"/>
                        <LabelInput redStar={true}>Mot de passe</LabelInput>
                        <Input type="password" name="password" onChange={handleChange} width="100%"/>
                        <LabelInput redStar={true}>Prénom</LabelInput>
                        <Input name="prenom" onChange={handleChange} width="100%"/>
                        <LabelInput redStar={true}>Nom</LabelInput>
                        <Input name="nom" onChange={handleChange} width="100%"/>
                        <Button inverted={true} value="">ENVOYER</Button>
                    </Formulaire>
                </Container>
            </Horizontal>
        </>
    )
}

const mapStateToProps = state => ({
    loginState: state.login,
    userState: state.user
})

const mapDispatchToProps = () => dispatch => ({
    actions: {
        login: bindActionCreators(allTheActions.login, dispatch),
        user: bindActionCreators(allTheActions.user, dispatch)
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Auth)
